import { getFirestore, collection, doc, getDoc, getDocs, addDoc, updateDoc, deleteDoc, query, where, orderBy, limit, startAfter, documentId, Timestamp, } from "firebase/firestore";
import { PageCursor } from "../../domain/models/pagination";
import { mapFirebaseError } from "./errorMapper";
import { serviceDTOtoDomain } from "./mappers";
export class FirebaseServiceRepository {
    db = getFirestore();
    coll = collection(this.db, "services");
    async fetchPage(pageSize, after) {
        try {
            let q = query(this.coll, orderBy("createdAt", "desc"), limit(pageSize));
            if (after?.backing) {
                q = query(q, startAfter(after.backing));
            }
            const snap = await getDocs(q);
            const items = snap.docs.map((d) => serviceDTOtoDomain(d.id, d.data()));
            const nextCursor = snap.docs.length === pageSize ? new PageCursor(snap.docs[snap.docs.length - 1]) : null;
            return { items, nextCursor };
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
    async fetchOwnerPage(userId, pageSize, after) {
        try {
            let q = query(this.coll, where("userId", "==", userId), orderBy("createdAt", "desc"), limit(pageSize));
            if (after?.backing) {
                q = query(q, startAfter(after.backing));
            }
            const snap = await getDocs(q);
            const items = snap.docs.map((d) => serviceDTOtoDomain(d.id, d.data()));
            const nextCursor = snap.docs.length === pageSize ? new PageCursor(snap.docs[snap.docs.length - 1]) : null;
            return { items, nextCursor };
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
    async fetchById(id) {
        try {
            const snap = await getDoc(doc(this.coll, id));
            if (!snap.exists())
                return null;
            return serviceDTOtoDomain(snap.id, snap.data());
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
    async fetchByIds(ids) {
        if (ids.length === 0)
            return [];
        try {
            const results = [];
            for (let i = 0; i < ids.length; i += 30) {
                const chunk = ids.slice(i, i + 30);
                const q = query(this.coll, where(documentId(), "in", chunk));
                const snap = await getDocs(q);
                snap.docs.forEach((d) => results.push(serviceDTOtoDomain(d.id, d.data())));
            }
            return results;
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
    async countOwned(userId) {
        try {
            const q = query(this.coll, where("userId", "==", userId));
            const snap = await getDocs(q);
            return snap.size;
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
    async create(input) {
        try {
            const docRef = await addDoc(this.coll, {
                ...input,
                imageUrls: input.imageUrls ?? [],
                createdAt: Timestamp.now(),
                commentCount: 0,
            });
            const snap = await getDoc(docRef);
            return serviceDTOtoDomain(docRef.id, snap.data());
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
    async update(service) {
        try {
            const { id, ...data } = service;
            await updateDoc(doc(this.coll, id), { ...data });
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
    async delete(serviceId) {
        try {
            await deleteDoc(doc(this.coll, serviceId));
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
}
//# sourceMappingURL=FirebaseServiceRepository.js.map